import { SquareBadge } from 'design-system/Badge';
import React from 'react';
import IconCheckMark from '../icons/IconCheckMark';
export const CheckMarkSquareBadge = (props) => (<SquareBadge {...props} border>
    <IconCheckMark />
  </SquareBadge>);
